import Alert from '@customink/pigment-react/lib/components/Alert';
import Link from '@customink/pigment-react/lib/components/Link';

import { CustomerCareNumber, WCIBMO_NAMES } from '@/constants';
import { useOrderQuantityType } from '@/hooks/useOrderQuantityType';
import { pageViewTag } from '@/utils/metrics';

export default function CanadaToUs() {
  const quantityType = useOrderQuantityType();

  pageViewTag(
    `checkout/summary/${quantityType}/wcibmo/${WCIBMO_NAMES.CANADA_PRODUCT_TO_US}`,
  );

  const customerCareLink = (
    <>
      {' '}
      <Link href={`tel:${CustomerCareNumber}`}>{CustomerCareNumber}</Link>{' '}
    </>
  );
  return (
    <Alert severity="warning">
      <strong>We are unable to ship this item to the United States.</strong>{' '}
      Please give us a call at {customerCareLink} and have a representative help
      you place your order, change delivery to a Canadian postal code, or swap
      to one of our U.S. products.
    </Alert>
  );
}
